import { render } from "./mainTitle.vue?vue&type=template&id=3cf02870&scoped=true"
import script from "./mainTitle.vue?vue&type=script&lang=js"
export * from "./mainTitle.vue?vue&type=script&lang=js"

import "./mainTitle.vue?vue&type=style&index=0&id=3cf02870&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3cf02870"

export default script